import { useState } from 'react';
import { retrySessionBootstrap } from '@/lib/session-bootstrap';
import { AuthCard } from '@/pages/AuthCard';
import { useAuthStore } from '@/stores/auth';

/**
 * Tela das rotas protegidas enquanto a renovação pelo cookie do carregamento não respondeu
 * (`restoring`): nenhuma decisão de login ainda.
 */
export function SessionRestoring() {
  return (
    <AuthCard title="Restaurando a sessão">
      <p className="muted" role="status">Carregando…</p>
    </AuthCard>
  );
}

/**
 * Tela das rotas protegidas quando a renovação do carregamento falhou por 429, 5xx ou rede
 * (`unavailable`). A sessão pode estar viva: nada é limpo, ninguém vai ao login, e a nova tentativa
 * só sai pelo botão, para não queimar o limite do `/refresh`, que é o mesmo do login.
 */
export function SessionUnavailable() {
  const message = useAuthStore((s) => s.sessionError);
  const [retrying, setRetrying] = useState(false);

  async function retry() {
    setRetrying(true);
    try {
      await retrySessionBootstrap();
    } finally {
      setRetrying(false);
    }
  }

  return (
    <AuthCard title="Não foi possível restaurar a sessão">
      <div className="error-banner" role="alert">
        {message ?? 'Não foi possível restaurar a sessão agora. Tente de novo em instantes.'}
      </div>
      <button type="button" className="btn" style={{ width: '100%' }} onClick={retry} disabled={retrying}>
        {retrying ? 'Tentando…' : 'Tentar de novo'}
      </button>
    </AuthCard>
  );
}
